/**
 * Link class
 *      - represents one mob in a chain:
 *      [ START ] > [ PREVIOUS ] > [ THIS ] > [ NEXT ] > ETC.
 */
export default class {
    constructor (mob, previousLink, distance) {
        this._distance = distance
        this._lastTargetLocation = null
        this._mob = mob
        this.game = mob.game
        this._previousLink = previousLink
        this._nextLink = null
    }

    attach (link) {
        this._nextLink = link
        link.setPreviousLink(this)
        return this
    }

    update (currentTime, isMoving, position) {
        if (position > 5) {
            this._mob.makePoisonous()
        }
        if (isMoving || !this._lastTargetLocation) {
            this._lastTargetLocation = this._previousLink.getLocation().clone()

            let distance = this.getLocation().clone().subtract(this._lastTargetLocation)
            if (distance.getMagnitude() > this._distance) {
                this._mob.moveTowards(this._lastTargetLocation)
                return this
            }
        }
        this._mob.break()
        return this
    }

    emitColor (color, onTime, travelTime) {
        this._mob.setColor(color, onTime)
        if (this._nextLink) {
            this.game.setTickTimeout(() => {
                this._nextLink.emitColor(color, onTime, travelTime)
            }, travelTime)
        }
        return this
    }

    break () {
        this._mob.break()
        return this
    }

    getLocation () {
        return this._mob.getLocation()
    }

    setPreviousLink (link) {
        this._previousLink = link
        return this
    }

    setDistance (distance) {
        this._distance = distance
        return this
    }
}
